var exports = {
  "kL": "DMSidebarSkeleton.module__container___SEtNSE",
  "Kd": "DMSidebarSkeleton.module__containerMobile___SEtNSE",
  "wx": "DMSidebarSkeleton.module__header___SEtNSE",
  "Od": "DMSidebarSkeleton.module__mobileHeader___SEtNSE",
  "Fy": "DMSidebarSkeleton.module__mobileHeaderActions___SEtNSE",
  "P1": "DMSidebarSkeleton.module__scrollArea___SEtNSE",
  "Qs": "DMSidebarSkeleton.module__content___SEtNSE",
  "wh": "DMSidebarSkeleton.module__mobileContent___SEtNSE",
  "jH": "DMSidebarSkeleton.module__spacer___SEtNSE",
  "nM": "DMSidebarSkeleton.module__row___SEtNSE",
  "TZ": "DMSidebarSkeleton.module__mobileRow___SEtNSE",
  "u4": "DMSidebarSkeleton.module__rowContent___SEtNSE",
  "yW": "DMSidebarSkeleton.module__channelInfo___SEtNSE",
  "jn": "DMSidebarSkeleton.module__channelNameRow___SEtNSE",
  "$s": "DMSidebarSkeleton.module__channelSubtextRow___SEtNSE",
  "me": "DMSidebarSkeleton.module__separator___SEtNSE",
  "bV": "DMSidebarSkeleton.module__sectionHeader___SEtNSE",
  "o5": "DMSidebarSkeleton.module__channelList___SEtNSE",
  "US": "DMSidebarSkeleton.module__bottomSpacer___SEtNSE",
  "cB": "DMSidebarSkeleton.module__mobileFab___SEtNSE",
};

module.exports = exports;
